var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container-fixed",attrs:{"id":"LOADING"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('VSpinner',{staticClass:"offset-top-2"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }